import { Injectable, inject } from '@angular/core';

import { Types } from '../../types.domain';

import { GetPylonCitiesServiceInterface } from '../interfaces/services/get-pylon-cities.service.interface';
import { GetPylonCitiesInput } from '../dtos/get-pylon-cities.input';
import { GetPylonCitiesOutput } from '../dtos/get-pylon-cities.output';

@Injectable()
export class GetPylonCitiesService implements GetPylonCitiesServiceInterface {
  private readonly _authRepository = inject(Types.AuthRepository);

  async handle(input: GetPylonCitiesInput): Promise<GetPylonCitiesOutput> {
    return await this._authRepository.getPylonCities(input);
  }
}
